class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

const EASING = 'cubic-bezier(.76,0,.24,1)';
const OPEN_POLY = 'polygon(0 0, 100% 0, 100% 100%, 0 100%)';
const CLOSED_POLY = 'polygon(0 0, 100% 0, 100% 0, 0 0)';
const DURATION = 400;

const OPEN_MENUS = new Set();

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    this.details = this.mainDetailsToggle;
    this.summary = this.details.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.hoverTimeout = null;
    this.animation = null;
    this.isClosing = false;

    this.content.style.display = 'block';
    this.content.style.overflow = 'hidden';
    this.content.style.clipPath = CLOSED_POLY;
    this.content.style.webkitClipPath = CLOSED_POLY;

    // Prevent click toggle on desktop, but allow <a> clicks
    this.summary.addEventListener('click', (event) => {
      if (event.target.closest('a')) return;

      // if (window.matchMedia('(hover: hover)').matches) {
      //   event.preventDefault();
      // }
    });

   // if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', () => {
        clearTimeout(this.hoverTimeout);

        OPEN_MENUS.forEach((menu) => {
          if (menu !== this) menu.close();
        });

        this.open();
      });

      this.addEventListener('mouseleave', () => {
        this.hoverTimeout = setTimeout(() => {
          this.close();
        }, 150);
      });
   // }
  }

  open() {
    if (this.isClosing) {
      this.isClosing = false;
      if (this.animation) this.animation.cancel();
      this.content.style.clipPath = OPEN_POLY;
      this.content.style.webkitClipPath = OPEN_POLY;
    }

    if (!this.details.hasAttribute('open')) {
      this.details.setAttribute('open', '');
    }
  }

  close() {
    if (this.isClosing) return;

    this.isClosing = true;

    if (this.animation) this.animation.cancel();

    this.animation = this.content.animate(
      [
        { clipPath: OPEN_POLY, webkitClipPath: OPEN_POLY },
        { clipPath: CLOSED_POLY, webkitClipPath: CLOSED_POLY }
      ],
      {
        duration: DURATION,
        easing: EASING,
        fill: 'forwards'
      }
    );

    this.animation.onfinish = () => {
      this.isClosing = false;
      super.close();
    };
  }

  onToggle() {
    if (this.header) {
      this.header.preventHide = this.details.open;

      if (
        document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === ''
      ) {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
      }
    }

    if (this.details.hasAttribute('open')) {
      OPEN_MENUS.add(this);
      this.animateOpen();
    } else {
      OPEN_MENUS.delete(this);
    }
  }

  animateOpen() {
    if (this.animation) this.animation.cancel();

    this.animation = this.content.animate(
      [
        { clipPath: CLOSED_POLY, webkitClipPath: CLOSED_POLY },
        { clipPath: OPEN_POLY, webkitClipPath: OPEN_POLY }
      ],
      {
        duration: DURATION,
        easing: EASING,
        fill: 'forwards'
      }
    );
  }
}

customElements.define('header-menu', HeaderMenu);


